import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../../context/ThemeContext';
import type { ColorTheme } from '../../utils/theme';
import { spacing, fontSize, fontWeight } from '../../utils/theme';
import type { UpsellCatalogItem } from './UpsellPolicyPicker';

/**
 * 1.4 R05: checkbox list of upsells a voucher / promo gives away free with the wash.
 */
export default function FreeUpsellPicker({ catalog, selected, onChange, title = 'Free add-ons with this wash', hint }: {
  catalog: UpsellCatalogItem[];
  selected: string[];
  onChange: (next: string[]) => void;
  title?: string;
  hint?: string;
}) {
  const { colors } = useTheme();
  const styles = makeStyles(colors);
  if (catalog.length === 0) return null;
  return (
    <View style={styles.wrap}>
      <Text style={styles.title}>{title}</Text>
      {hint ? <Text style={styles.hint}>{hint}</Text> : null}
      {catalog.map(u => {
        const on = selected.includes(u.id);
        return (
          <TouchableOpacity key={u.id} style={styles.row} onPress={() => onChange(on ? selected.filter(x => x !== u.id) : [...selected, u.id])}
            accessibilityRole="checkbox" accessibilityState={{ checked: on }} accessibilityLabel={u.name}>
            <Ionicons name={on ? 'checkbox' : 'square-outline'} size={20} color={colors.primary} />
            <Text style={styles.name}>{u.name} · ${(u.priceCents / 100).toFixed(2)}</Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
}

const makeStyles = (c: ColorTheme) => StyleSheet.create({
  wrap: { marginTop: spacing.sm, marginBottom: spacing.md },
  title: { fontSize: fontSize.sm, fontWeight: fontWeight.semibold, color: c.text, marginBottom: 2 },
  hint: { fontSize: fontSize.xs, color: c.textSecondary, marginBottom: spacing.xs },
  row: { flexDirection: 'row', alignItems: 'center', paddingVertical: 6 },
  name: { marginLeft: 8, fontSize: fontSize.sm, color: c.text },
});
